module.exports = {
    i18n: {
        defaultLocale: "en",
        locales: ["en", "cs"],
    },
    ns: ["common"],
    serializeConfig: false,
    localePath: (locale, namespace, missing) => {
        const path = missing ? "/locales/common/en.json" : `/locales/${namespace}/${locale}.json`
        return typeof window === "undefined" ? require("path").resolve("./public" + path) : path
    },
}
